/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MsftModal',['pixi', 'absolute','MenuUI/MsftButton','lodash', 'MenuUI/ControlFocusManager'],
    function (PIXI, Absolute, MsftButton, _, ControlFocusManager) {

        var MsftModal = function (ui, game, options) {
            var defaultOptions = {
                width: Absolute.Coords.x(1920),
                height: Absolute.Coords.y(294),
                displayCloseButton: false,
                backgroundAlpha: 0.5,
                buttonLetterStyle: {
                    font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 33 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                dialog: '',
                buttons: [],
                backgroundColor: 0xffffff
            };

            this.initMsftModal(ui, game, _.extend(defaultOptions, options));
        };

        MsftModal.prototype = Object.create(Absolute.Dialog.prototype);

        MsftModal.prototype.initMsftModal = function (ui, game, options) {

            this.ui = ui;
            this.game = game;
            this.options = options;
            this.options.content = this.initContent();

            this.controlFocusManager = new ControlFocusManager();

            Absolute.Dialog.call(this, ui, this.options);
            this.options.tween.type = 'tweenIn';

            //this.addButtons(this.options.buttons);
        };

        MsftModal.prototype.initContent = function () {
            this.contentContainer = Absolute.UIBuilder.buildLayout(this.options.dialog, this, this, this.options.width, this.options.height);
            return this.contentContainer;
        };

        MsftModal.prototype.cleanUp = function() {
            Absolute.SpriteUtils.destroyAllChildren(this);
            this.destroy(true);
        };

        MsftModal.prototype.addButtons = function(buttons) {
            _.each(buttons, function(options) {
                var button;
                options.width = Absolute.Coords.x(options.width);
                options.height = Absolute.Coords.x(options.height);
                button = new MsftButton(options);
                button.x = Absolute.Coords.x(options.position.x);
                button.y = Absolute.Coords.x(options.position.y);
                this.addChild(button);
                this.controlFocusManager.addControl(button, true);
            }, this);
        };

        MsftModal.prototype._createBackground = function() {

            var background = new PIXI.Graphics();

            background.beginFill(this.options.backgroundColor, 1);
            background.drawRect(0, 0,this.options.width, this.options.height);
            background.endFill();

            this.addChildAt(background,0);

        };

        MsftModal.prototype.handleCommand = function (command) {
            switch (command) {
                case 'Tab':
                case 'Right':
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'ShiftTab':
                case 'Left':
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;
            }
        };

        MsftModal.prototype.onShow = function () {
            Absolute.Dialog.prototype.onShow.call(this);
            //this.controlFocusManager.focusNextControl(1);
        };

        return MsftModal;

    });

